import React, { useRef } from 'react';
import classNames from 'classnames';
import styles from './dropdown-menu.module.css';
import { ArrowIcon, ChevronIcon } from '../../../../design';
export function DropdownMenuTrigger(props) {
    var _a, _b, _c, _d, _e;
    var 
    // html props
    disabled = props.disabled, multiple = props.multiple, 
    // custom props
    label = props.label, selectedItems = props.selectedItems, validation = props.validation, large = props.large, open = props.open, onBlur = props.onBlur, onFocus = props.onFocus, bottomQuadrant = props.bottomQuadrant;
    var buttonRef = useRef(null);
    return (React.createElement(React.Fragment, null,
        React.createElement("label", { htmlFor: label, className: "inputLabel inputText" }, label),
        !open && !!((_a = selectedItems[0]) === null || _a === void 0 ? void 0 : _a.icon) && React.createElement("div", { className: "inputIcon prefix" }, (_b = selectedItems[0]) === null || _b === void 0 ? void 0 : _b.icon),
        React.createElement("button", { ref: buttonRef, id: label, disabled: disabled, className: classNames('inputTriggerWrapper inputTrigger inputText', styles.dropdownMenuTrigger), onClick: function () {
                if (!buttonRef.current || open)
                    return;
                buttonRef.current.focus();
            }, onFocus: onFocus, onBlur: onBlur }, !open && (React.createElement("div", { className: styles.dropdownMenuTriggerValues },
            React.createElement("div", { className: "inputText" }, (_d = (_c = selectedItems[0]) === null || _c === void 0 ? void 0 : _c.label) !== null && _d !== void 0 ? _d : (_e = selectedItems[0]) === null || _e === void 0 ? void 0 : _e.value),
            multiple && selectedItems.length > 1 && (React.createElement("div", { className: classNames([styles.dropdownMenuTriggerOther]) },
                "(+ ",
                selectedItems.length - 1,
                " other",
                selectedItems.length > 2 ? 's' : '',
                ")"))))),
        React.createElement("div", { className: "inputIcon suffix" }, large ? (React.createElement(ChevronIcon, { tone: disabled ? 'default' : 'primary', rotation: open ? 4 : 2 })) : (React.createElement(ArrowIcon, { tone: disabled ? 'default' : 'primary', rotation: open ? 3 : 1 })))));
}
